import {
  DeleteFilesAction,
  DeleteFilesPayload,
  FetchFilesAction,
  FetchFilesPayload,
  GetListFilesAction,
  GetListFilesPayload,
  SelectAllFileAction,
  SelectAllFilePayload,
  UpdateLoadingStatusAction,
  UpdateLoadingStatusPayload,
  UpdateReadTokenAction,
  UpdateReadTokenPayload,
  UpdateSelectFileAction,
  UpdateSelectFilePayload,
} from 'types/actions/document';

import { documentConstant } from '../actionTypes';

export const fetchFiles = (payload: FetchFilesPayload): FetchFilesAction => ({
  type: documentConstant.GET_FILES,
  payload,
});

export const getListFiles = (payload: GetListFilesPayload): GetListFilesAction => ({
  type: documentConstant.FETCH_DATA_FILES,
  payload,
});

export const updateSelectFile = (payload: UpdateSelectFilePayload): UpdateSelectFileAction => ({
  type: documentConstant.UPDATE_SELECT_FILE,
  payload,
});

export const selectAllFile = (payload: SelectAllFilePayload): SelectAllFileAction => ({
  type: documentConstant.SELECT_ALL_FILE,
  payload,
});

export const deleteFiles = (payload: DeleteFilesPayload): DeleteFilesAction => ({
  type: documentConstant.DELETE_FILES,
  payload,
});

export const updateLoadingStatus = (
  payload: UpdateLoadingStatusPayload
): UpdateLoadingStatusAction => ({
  type: documentConstant.UPDATE_LOADING_STATUS,
  payload,
});

export const getReadToken = () => ({
  type: documentConstant.GET_READ_TOKEN,
});

export const updateReadToken = (payload: UpdateReadTokenPayload): UpdateReadTokenAction => ({
  type: documentConstant.UPDATE_READ_TOKEN,
  payload,
});
